import React from "react";

const MscPrepaidTax = React.lazy(() => import("./MSCPrepaidTax/MscPrepaidTax"));
const MscSummary = React.lazy(() => import("./MSCSummary/MscSummary"));
const MscSalary = React.lazy(() => import("./MSCSalary/MscSalary"));
const MscTax = React.lazy(() => import("./MSCTax/MscTax"));
const MscFamily = React.lazy(() => import("./MSCFamily/MscFamily"));

const MSCRoute = {
  MSCTax: {
    url: "/msc/tax",
    component: MscTax,
  },
  MSCPrepaidTax: {
    url: "/msc/prepaid-tax",
    component: MscPrepaidTax,
  },
  MSCFamily: {
    url: "/msc/family",
    component: MscFamily,
  },
  MSCSummary: {
    url: "/msc/summary",
    component: MscSummary,
  },
  MSCSalary: {
    url: "/msc",
    component: MscSalary,
    checkInputStep: true,
  },
};
export default MSCRoute;
